<style lang="scss" scoped>
.scroll-view {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  &.flex {
    flex: auto;
  }
  &.absolute {
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
  }
  &.scroll-x {
    overflow-x: auto;
    writing-mode: vertical-lr; // 改变文档流方向
  }
  &.scroll-y {
    overflow-y: auto;
  }
  .finish {
    height: 58px;
    @include text(11px, #999);
    @include flex-row-center;
  }
  .logo {
    width: 123px;
    height: 18px;
  }
}
</style>

<template>
  <div
    :class="[
      'scroll-view',
      display,
      { 'scroll-x': !scrollY && scrollX, 'scroll-y': scrollY }
    ]"
    @scroll="hanlderScroll"
  >
    <slot />
    <div v-if="withBottom && (loading || finish)" class="scroll-bottom">
      <p v-show="loading" class="loading">
        <span>加载中</span>
      </p>
      <p v-show="finish" class="finish">
        <img
          v-if="useLogo"
          src="@/images/goods_rank/bottom_tip_logo_mall.png"
          class="logo"
        />
        <span v-else>-已经到底啦-</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'McScrollView',
  model: {
    event: 'scroll'
  },
  props: {
    // 设置展示模式是flex，还是absolute
    display: {
      default: 'flex',
      validator: function (value) {
        return ['absolute', 'flex'].indexOf(value) !== -1
      }
    },
    // 开启横向滚动，默认不开启
    scrollX: {
      type: Boolean,
      default: false
    },
    // 开启纵向滚动，默认不开启
    scrollY: {
      type: Boolean,
      default: false
    },
    // 距底部/右边多远时，触发scrolltolower事件
    lowerThreshold: {
      type: Number,
      default: 50
    },
    // 设置垂直/水平滚动位置
    value: {
      type: Number,
      default: 0
    },
    // 在设置滚动条位置时使用动画过渡
    scrollWithAnimation: {
      type: Boolean,
      default: false
    },
    withBottom: {
      type: Boolean,
      default: false
    },
    finish: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    useLogo: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(n, o) {
      if (n >= 0) {
        if (this.scrollWithAnimation) {
          // 防止在缓动过程中继续触发滚动
          if (!this._smoothScrolling) {
            this.smoothScroll(n)
          }
        } else {
          this.smoothScroll(n, 1)
        }
      }
    }
  },
  mounted() {
    // 定义动画执行器
    this.requestAnimationFrame = window.requestAnimationFrame
      ? window.requestAnimationFrame
      : function (aniFunc) {
          window.setTimeout(aniFunc, 17)
        }
  },
  throttleTag: false,
  methods: {
    smoothScroll(end, rate = 8) {
      const direction = this.scrollY
        ? 'scrollTop'
        : this.scrollX
        ? 'scrollLeft'
        : null
      if (!direction) return false
      let current = this.$el[direction]
      if (current === end) return false
      if (rate === 1) {
        this.$el[direction] = end
        return true
      }
      const step = () => {
        current = current + (end - current) / rate
        if (Math.abs(end - current) < 1) {
          this.$el[direction] = end
          this._smoothScrolling = false
          return true
        }
        this.$el[direction] = current
        this.requestAnimationFrame(step)
      }
      step()
      this._smoothScrolling = true
    },
    hanlderScroll(e) {
      const { currentTarget } = e
      if (this.scrollY) {
        this.$emit('scroll', e.currentTarget.scrollTop)
        if (
          currentTarget.scrollTop + currentTarget.offsetHeight >
          currentTarget.scrollHeight - this.lowerThreshold
        ) {
          if (!this.throttleTag) {
            this.throttleTag = true
            this.$emit('scroll-to-lower')
          }
        } else {
          if (this.throttleTag) {
            this.throttleTag = false
          }
        }
      } else if (this.scrollX) {
        this.$emit('scroll', e.currentTarget.scrollLeft)
        if (
          currentTarget.scrollLeft + currentTarget.offsetWidth >
          currentTarget.scrollWidth - this.lowerThreshold
        ) {
          if (!this.throttleTag) {
            this.throttleTag = true
            this.$emit('scroll-to-lower')
          }
        } else {
          if (this.throttleTag) {
            this.throttleTag = false
          }
        }
      }
    }
  }
}
</script>
